module.exports = __webpack_public_path__ + "img/bg-us2.cb25bd47.jpg";